import { render, staticRenderFns } from "./V3TeamLogo.vue?vue&type=template&id=49424d35&scoped=true&"
import script from "./V3TeamLogo.vue?vue&type=script&lang=js&"
export * from "./V3TeamLogo.vue?vue&type=script&lang=js&"
import style0 from "./V3TeamLogo.vue?vue&type=style&index=0&id=49424d35&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49424d35",
  null
  
)

export default component.exports